export function getBackNavigationTarget(ref: readonly string[]): 'idle' | 'home' | 'history' {
  switch (ref.at(-1)) {
    case 'idle': return 'idle';
    case 'tab-bar': return 'home';
    default: return 'history';
  }
}
